export default __webpack_public_path__ + "static/media/deviceDeleteIcon.dd3ecc5c.svg";